// All over the file changes has been done by Dev srini on 07/08/24

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { withStyles } from '@material-ui/core/styles'
import { Checkbox, FormControlLabel, Button } from '@material-ui/core'

import styles from '../InCompleteKYCStyles'

const FilterFields = ({
    classes, kycFdate, kycTdate, handleKycFDate, handleKycTDate,
    checkboxToggle, handlecheckboxChange, status, setStatus,hide, setHide, count //dev-trupti on 26-11-2024
}) => {

    return (
        <div style={{ display: 'flex', justifyContent: count !== undefined && count !== null ? 'space-between' : "end", width: '100%' }}>
       {count !== undefined && count !== null &&  <h3 style={{ color: "white", fontFamily: 'cardiuma-regular', margin:"0px",paddingTop:"5px"}}>No of Records - {count}</h3>  }
            <form className={classes.kycFilterfield}>
                    
                    <span className={classes.checkBoxNew}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxToggle === "completed"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        setHide(false)
                                        handlecheckboxChange(e, "completed")}}
                                />
                            }
                            label="Completed"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={checkboxToggle === "in_progress"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        setHide(true)
                                        setStatus(false)
                                        handlecheckboxChange(e, "in_progress")}}
                                />
                            }
                            label="Incomplete"
                        />
                    {/* Added bank pending checkbox by dev-trupti on 26-08-2024 */}
                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={checkboxToggle === "document_verification"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        
                                        handlecheckboxChange(e, "document_verification")
                                    }}
                                />
                            }
                            label="Document Verification"
                        />
                        {/* Added Inactive checkbox by dev-trupti on 26-08-2024 */} 
                        {/* {hide && <FormControlLabel
                            control={
                                <Checkbox
                                checked={status === true}
                                onChange={(e) =>{
                                    if(e.target.checked){
                                        setStatus(e.target.checked)
                                        handlecheckboxChange(e, "incompleted","INACTIVE")
                                    }else{
                                        setStatus(e.target.checked)
                                        handlecheckboxChange(e, "incompleted","ACTIVE")
                                    }}}
                                />
                            }
                            label="Archieved"
                        />} */}
                    </span>

                    
                {/* </LocalizationProvider> */}
            </form>
        </div>
    )
}

export default withStyles(styles)(FilterFields)
